import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { DialogTitle } from '@/components/ui/dialog'
import { useHall } from '@/contexts/HallProvider'
import { SpeakingRole } from '@db8/shared'
import { useHallUsers } from '@/contexts/HallUsersProvider'
import { usePoll } from '@/contexts/PollProvider'
import { Textarea } from '@/components/ui/textarea'

export const SimplePoll = ({ onNext, allowFeedback = false }) => {
  const [selectedOption, setSelectedOption] = useState<
    SpeakingRole.Affirmative | SpeakingRole.Negative | null
  >(null)
  const { hall } = useHall()
  const { vote } = usePoll()
  const { currentUser } = useHallUsers()
  const [reasoning, setReasoning] = useState('')

  const handleSubmit = () => {
    if (!selectedOption) return

    vote(currentUser, selectedOption, reasoning)
    onNext()
  }

  const options = [
    {
      name: hall.affirmingTeamName,
      SpeakingRole: SpeakingRole.Affirmative,
    },
    {
      name: hall.dissentingTeamName,
      SpeakingRole: SpeakingRole.Negative,
    },
  ]
  return (
    <div className="flex flex-col gap-4 h-full">
      <DialogTitle className="text-xl font-semibold mb-2 text-center">
        Who Won This Debate?
      </DialogTitle>
      <div className="flex w-full items-center justify-between space-x-2">
        {options.map((option) => (
          <Button
            key={`${option.SpeakingRole}`}
            variant="outline"
            // @ts-ignore
            onClick={() => setSelectedOption(option.SpeakingRole)}
            className={`w-full text-white hover:text-white font-bold hover:opacity-75 ${
              option.SpeakingRole === 'Affirmative'
                ? 'gradient-bg-affirmative'
                : 'gradient-bg-negative'
            } ${
              selectedOption && selectedOption !== option.SpeakingRole ? 'opacity-50' : 'opacity-1'
            }`}
          >
            {option.name}
          </Button>
        ))}
      </div>
      {allowFeedback && (
        <Textarea
          placeholder="Add your reasoning for the decision..."
          value={reasoning}
          onChange={(e) => setReasoning(e.target.value)}
          className="mt-auto h-full border border-gray-300 dark:text-white rounded p-2"
          rows={12}
        />
      )}
      <div className="mt-4 flex justify-center">
        <Button
          variant="secondary"
          disabled={!selectedOption}
          onClick={handleSubmit}
          className="w-full text-black"
        >
          Vote
        </Button>
      </div>
    </div>
  )
}
